module.exports = __webpack_public_path__ + "resources/img/logo_partner_public_edupang_m.02f37fdc6850452d4b284acaafffe8c8.png";